export default {
    'required': 'This is required',
    'too_short': 'Enter at least {min} characters',
    'too_long': 'Keep this to {max} characters or fewer',
    'invalid_email': 'Enter a valid email address',
    'invalid_phone': 'Enter a valid phone number',
    'invalid_date': 'Enter a valid date',
    'date_in_future': 'This date cannot be in the future',
    'number_min': 'Enter {min} or more',
    'number_max': 'Enter {max} or less',
    'whole_number': 'Enter a whole number',
    'money_whole_units': 'Enter a whole amount, with no decimals',
    'money_invalid': 'Enter an amount such as {example}',
    'choose_one': 'Choose one',
};
//# sourceMappingURL=validation.js.map